import { render, staticRenderFns } from "./top-banner.vue?vue&type=template&id=2c03d652&scoped=true&"
import script from "./top-banner.vue?vue&type=script&lang=js&"
export * from "./top-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c03d652",
  null
  
)

export default component.exports